import { render, staticRenderFns } from "./inputPositionFan.vue?vue&type=template&id=3bf60d7a&scoped=true&"
import script from "./inputPositionFan.vue?vue&type=script&lang=js&"
export * from "./inputPositionFan.vue?vue&type=script&lang=js&"
import style0 from "./inputPositionFan.vue?vue&type=style&index=0&id=3bf60d7a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf60d7a",
  null
  
)

export default component.exports